import { IBannerInlinePlaceholderProps } from '@tekface/smart-activation';
import {
  BlockType,
  DiscoveryBlock,
  DiscoveryProduct,
  PageTypeEnum,
} from '@teko/discovery';
import { styled } from '@teko/ds-desktop';
import { ProductCardProps } from '@teko/types/ecommerce';
import { MegaMenuItemInterface } from '@teko/types/pb';
import { DiscoveryBlocks } from 'components/desktop/organisms';
import { useTenantConfig } from 'contexts';
import { findBlockByType } from 'helpers';
import { useHomePage } from 'hooks';
import dynamic from 'next/dynamic';
import React from 'react';
import { AboveTheFold, NewLayoutAboveTheFold, SideBanners } from './components';

const PopupPromotion = dynamic(() =>
  import('components/PopupPromotion').then((mod) => mod.PopupPromotion),
);
const QuestionnairesModal = dynamic(
  () => import('components/QuestionnairesModal'),
);

const StyledSideBanners = styled(SideBanners)`
  top: 8px;
  > div {
    margin-top: 88px;
  }
`;
export interface DefaultHomeProps {
  serverBlocks: DiscoveryBlock[];
  menuItems?: MegaMenuItemInterface[];
  mapProducts?: { [key: string]: DiscoveryProduct[] }; // for SSR
  ssrProducts?: { [blockId: string]: ProductCardProps[] };
  inlineBanners?: IBannerInlinePlaceholderProps<{}>['banners'];
}

export const DefaultHome: React.FC<DefaultHomeProps> = ({
  serverBlocks,
  menuItems = [],
  ssrProducts = {},
  inlineBanners,
}: DefaultHomeProps) => {
  const {
    questionnairesUrl,
    megaMenuType = 'vertical',
    isBot,
    displayNewLayoutForPageBuilderV1,
  } = useTenantConfig();

  const {
    slideBanners,
    topRightBanners,
    blocks,
    popupBanner,
    horizontalFourBanners,
  } = useHomePage(serverBlocks);

  const showPopupBanner = popupBanner && popupBanner?.cookedData?.[0];

  return (
    <>
      {showPopupBanner && !isBot && (
        <PopupPromotion banner={popupBanner.cookedData[0]} />
      )}
      {displayNewLayoutForPageBuilderV1 ? (
        <NewLayoutAboveTheFold
          menuItems={
            megaMenuType === 'vertical' &&
            findBlockByType(BlockType.MEGA_MENU, blocks)
              ? menuItems
              : []
          }
          slideBanners={slideBanners}
          horizontalFourBanners={horizontalFourBanners}
          topRightBanners={topRightBanners}
        />
      ) : (
        <AboveTheFold
          menuItems={
            megaMenuType === 'vertical' &&
            findBlockByType(BlockType.MEGA_MENU, blocks)
              ? menuItems
              : []
          }
          slideBanners={slideBanners}
          topRightBanners={topRightBanners}
          horizontalFourBanners={horizontalFourBanners}
        />
      )}
      <StyledSideBanners />
      <DiscoveryBlocks
        blocks={blocks}
        ssrMapProducts={ssrProducts}
        inlineBanners={inlineBanners}
        pageTypeEnum={PageTypeEnum.HOME}
      />
      {questionnairesUrl && !isBot && <QuestionnairesModal />}
    </>
  );
};
